"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var totalCalls_1 = require("../total-calls/totalCalls");
var callDurations_1 = require("../../active-report/call-durations/callDurations");
var callStatistics_1 = require("../call-statistics/callStatistics");
var queueTime_1 = require("../queue-time/queueTime");
var callDuration_1 = require("../call-duration/callDuration");
var talkTime_1 = require("../talk-time/talkTime");
var emotion_1 = require("emotion");
var description_1 = require("../../common/description/description");
var core_components_1 = require("@securityproducts/core-components");
var historicalReportPlaceholder_page_1 = require("./placeholder/historicalReportPlaceholder.page");
function HistoricalReportAllAgentsPage(props) {
    if (props.hasSearched === false) {
        return React.createElement(historicalReportPlaceholder_page_1.HistoricalReportsPlaceholder, { language: props.language });
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: sectionPadding },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(description_1.Description, __assign({}, props.description, { language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(totalCalls_1.TotalCalls, __assign({}, props.totalCalls, { language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(callDurations_1.CallDurations, __assign({}, props.callDurations, { language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(callStatistics_1.CallStatistics, __assign({}, props.callStatistics, { language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(queueTime_1.QueueTime, __assign({}, props.queueTime, { language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(talkTime_1.TalkTime, __assign({}, props.talkTime, { display: props.display, language: props.language })))),
        React.createElement("div", { className: sectionMargin },
            React.createElement(core_components_1.ErrorBoundary, null,
                React.createElement(callDuration_1.CallDuration, __assign({}, props.callDuration, { display: props.display, language: props.language }))))));
}
exports.HistoricalReportAllAgentsPage = HistoricalReportAllAgentsPage;
var sectionMargin = emotion_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 20px;\n"], ["\n    margin-bottom: 20px;\n"])));
var sectionPadding = emotion_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 20px;\n"], ["\n    padding: 0 20px;\n"])));
var templateObject_1, templateObject_2;
